import faker from 'faker';
import PageContainer from './PageContainer';
import session from '../models/Session';
import Draft from '../models/Draft';
import DraftSession from '../models/DraftSession';
import mockTemplates from './__mocks__/templates.json';
import socket from '../libraries/socket';

export default class EndSessionContainer extends PageContainer {
  state = {
    allowedDisplayedCardToParticipant: [],
    template: null, 
    draft: null, 
    draftSessions: {
      next: null,
      current: null,
      completed: [],
      remaining: []
    },
    participants: [
      {
        _id: 1,
        displayName: faker.name.findName(),
        image: faker.image.avatar(),
      },
      {
        _id: 2,
        displayName: faker.name.findName(),
        image: faker.image.avatar(),
      },
      {
        _id: 3,
        displayName: faker.name.findName(),
        image: faker.image.avatar(),
      },
    ],
    createdBy: {
      displayName: faker.name.findName(),
      image: faker.image.avatar(),
    },
    hideEndedSession: true,
    modal: false,
  }

  options = {
    getFromSession: ['template', 'draftSessions', 'draft'],
    defaultState: {
      template: (mockTemplates || []).filter(t => /Issue/i.test(t.name)).pop(),
      draft: Draft.mock(),
      draftSessions: DraftSession.mockState({type: 'end'})
  },
  flags: [{
      name: 'isLoaded',
      check: () => true,
    }],
  }

  async setup() {
    await this.subscribeToSession();
    if (!(this.state.draft && this.state.template)) {
      await session.fetchLocal();
    }

    // if (!(this.state.draft && this.state.draftSessions && this.state.template)) {
    //   await session.fetchLocal();
    //   // session.selectTe\mplate(this.options.defaultState.template);
    //   // session.selectCard(this.options.defaultState.selectedParents);
    //   // const draft = session.createDraft();
    //   // console.log(draft);
    //   // session.startJam(draft);
    // }

    session.endDraftSession();
    socket.syncWithParticipants();
  }

  destroy() {
    this.unsubscribeAll();
  }

  handleChange = (object) => (event) => {

  }

  handleClickShowEndedSession = () => {
    this.setState({
      hideEndedSession: !this.state.hideEndedSession,
    });
  }

  toggleModal = () => {
    this.setState({
      modal: !this.state.modal,
    });
  }

  removeFromFutureBtn = (id) => {
    this.toggleModal();
    this.setState({
      participants: [...this.state.participants].filter(participant => participant._id !== id),
    });
  }

  removeFromPreviousBtn = (id) => {
    this.toggleModal();
    this.setState({
      participants: [...this.state.participants].filter(participant => participant._id !== id),
    });
  }

  constructor(props) {
    super(props);
    this.getPropsFromSession(this.options.getFromSession);
    this.setupFlags(this.options.flags);
  }
}



// WEBPACK FOOTER //
// ./src/containers/EndSessionContainer.js